const CategoriesRoutes = {
  getAllcategories: "/marketplace/categories",
  createcategory: "/marketplace/categories/create",
  updateCategory: "/marketplace/categories/update",
  deletCategory: "/marketplace/categories/delete",
  uploadImage: "/marketplace/categories/upload",
};

export default CategoriesRoutes;
